import { setupFiMigrationTrackingListener } from 'app-components/store/listeners';

import { startAppListening } from '../listenerMiddleware';

setupFiMigrationTrackingListener(startAppListening);
